import gsap from 'gsap';
import { Container, Graphics, Rectangle, Sprite } from 'pixi.js';
import { config } from '../config/config'; // for DEBUG value only
import { Coordinates, Dimensions } from './declarations/PositionInfo';

const SHOW_TWEEN_DUATION = 0.4;

export default class ActiveItem extends Container {
  public id: string;
  public center: Coordinates;
  private hoverStateSprite: Sprite;
  private normalStateSprite: Sprite;
  private isHovered: boolean;
  private hitAreaDebugRect: Rectangle;

  constructor(id: string, position: Coordinates, hitArea: Coordinates & Dimensions) {
    super();

    this.id = id;

    this.x = Math.round(position.x);
    this.y = Math.round(position.y);

    this.hitArea = new Rectangle(hitArea.x - position.x, hitArea.y - position.y, hitArea.w, hitArea.h) as Rectangle;
    this.hitAreaDebugRect = this.hitArea as Rectangle;

    this.center = {
      x: hitArea.x + hitArea.w / 2,
      y: hitArea.y + hitArea.h / 2,
    };

    this.hoverStateSprite = Sprite.from(`${this.id}_1.png`);
    this.addChild(this.hoverStateSprite);
    this.hoverStateSprite.visible = false;
    this.normalStateSprite = Sprite.from(`${this.id}_0.png`);
    this.addChild(this.normalStateSprite);

    this.isHovered = false;
    this.visible = false;

    this.eventMode = 'passive';
    this.alpha = 0;
    this.zIndex = 3;

    if (config.DEBUG) {
      this._drawHitArea();
    }
  }

  show(doShow: boolean, now: boolean = false) {
    if (doShow) {
      this.eventMode = 'static';
      this.cursor = 'pointer';
      this.visible = true;
    } else {
      this.eventMode = 'passive';
      this.cursor = 'default';
    }

    gsap.killTweensOf(this);
    const duration = now ? 0 : SHOW_TWEEN_DUATION;
    gsap.to(this, {
      duration: duration,
      alpha: doShow ? 1 : 0,
      //ease: 'sine.out',
      onComplete: () => {
        this.visible = doShow;
      },
    });
  }

  getCenterPosition() {
    return this.center;
  }

  setHoverState(doHover: boolean) {
    if (doHover === this.isHovered) {
      return;
    }
    this.isHovered = doHover;
    this.hoverStateSprite.visible = doHover;
    this.normalStateSprite.visible = !doHover;
  }

  _drawHitArea() {
    const debugGr = new Graphics();

    debugGr.beginFill('0xFF0000', 0.4);
    debugGr.drawRect(
      this.hitAreaDebugRect.x,
      this.hitAreaDebugRect.y,
      this.hitAreaDebugRect.width,
      this.hitAreaDebugRect.height,
    );
    debugGr.endFill();

    //top left
    debugGr.beginFill('0xFFFF00', 0.4);
    debugGr.drawCircle(this.hitAreaDebugRect.x, this.hitAreaDebugRect.y, 5);
    debugGr.endFill();

    //center
    debugGr.beginFill('0x0000FF', 0.4);
    debugGr.drawCircle(this.center.x - this.x, this.center.y - this.y, 5);
    debugGr.endFill();

    this.addChild(debugGr);
  }
}
